var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96391 8.23535H1.36719V22.8927H5.96391V8.23535Z",
    fill: "black",
    fillOpacity: 0.44
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4017 7.91773C18.2322 7.89655 18.0521 7.88595 17.8721 7.87536C15.2983 7.76946 13.8473 9.2945 13.3389 9.95112C13.2012 10.1312 13.1377 10.2371 13.1377 10.2371V8.27781H8.74219V22.9352H13.1377H13.3389C13.3389 21.4419 13.3389 19.9592 13.3389 18.466C13.3389 17.6611 13.3389 16.8562 13.3389 16.0513C13.3389 15.0558 13.2648 13.9967 13.7626 13.0859C14.1862 12.3234 14.9488 11.9421 15.8067 11.9421C18.3487 11.9421 18.4017 14.2403 18.4017 14.4521C18.4017 14.4627 18.4017 14.4733 18.4017 14.4733V22.9987H22.9984V13.4354C22.9984 10.1629 21.3355 8.23544 18.4017 7.91773Z",
    fill: "black",
    fillOpacity: 0.44
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66906 6.34059C5.14314 6.34059 6.33813 5.14571 6.33813 3.67176C6.33813 2.1978 5.14314 1.00293 3.66906 1.00293C2.19498 1.00293 1 2.1978 1 3.67176C1 5.14571 2.19498 6.34059 3.66906 6.34059Z",
    fill: "black",
    fillOpacity: 0.44
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b16e6658a7f78b22fcebe4e46ddefeb6.svg";
export { ForwardRef as ReactComponent };